import { assertLayoutNodeExhaustive } from './layoutAssertNever';
import { walkLayoutStructureChildren } from './layoutStructureChildLists';
import type { LayoutNode } from './types';

/**
 * QIDs that render as answer controls in bespoke layout_json.
 *
 * Walks the entire tree including both branches of each `conditional` (fields might live in either).
 * Ignores `sum`, conditional `when`, `repeat.over` — those are not rendered inputs.
 * `OASISMultiselectOption` rows share the parent `OASISMultiselect` qid; not listed separately.
 */
export function collectLayoutRenderableFieldQids(
  nodes: LayoutNode[]
): Set<string> {
  const ids = new Set<string>();
  const walk = (arr: LayoutNode[]) => {
    for (const node of arr) {
      switch (node.type) {
        case 'card':
        case 'stack':
        case 'grid':
        case 'flex':
        case 'box':
        case 'indent':
        case 'field-row':
        case 'divider':
        case 'static':
        case 'text':
        case 'display':
        case 'section-label':
        case 'sum':
        case 'table':
        case 'conditional':
        case 'disabled-when':
        case 'repeat':
        case 'OASISMultiselectOption':
          break;
        case 'OASISRadio':
        case 'OASISYesNoCheckbox':
        case 'OASISSelect':
        case 'OASISText':
        case 'OASISDate':
        case 'OASISTime':
        case 'OASISNumber':
          ids.add(node.qid);
          break;
        case 'OASISMultiselect':
          ids.add(node.qid);
          break;
        case 'radio-option':
          ids.add(node.qid);
          break;
        default:
          assertLayoutNodeExhaustive(node);
      }
      walkLayoutStructureChildren(node, walk);
    }
  };
  walk(nodes);
  return ids;
}
